export const getShortUrlFromUrl = () => {
  const pathname = window.location.pathname;
  const pathArray = pathname.split('/');
  if (pathArray.length) {
    return pathArray[pathArray.length - 1];
  }

  return null;
};

export const getSampleFromUrl = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const sample = urlParams.get('sample');
  return sample !== null;
};

export const getMergeCodeFromUrl = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('email');
};
